// Centralized route targets.
// NOTE: /login, /register and /pay/* are handled by the existing 66biolinks
// PHP application (NOT React Router). Always link to them with plain <a href>
// or window.location so the browser performs a full navigation.
export const ROUTES = {
  home: "/",
  login: "/login",
  register: "/register",
  pricing: "#pricing",
  privacy: "/privacy-policy",
  terms: "/terms-conditions",
  refund: "/refund-policy",
};
